import { useMemo } from 'react';

import { useClientController_RangeLiceReports } from '@/services/hooks';
import type { RangeClientReportResult } from '@/services/types';

import type { DomainQueryOptions } from '../shared/types';

import { mapRangeClientReportResultToDomain } from './mappers';
import type { UseGetRegionRangeLiceReportResult } from './types';

export const useGetRegionRangeLiceReport = (
    clientId: number,
    from: string,
    to: string,
    options?: DomainQueryOptions<RangeClientReportResult>
): UseGetRegionRangeLiceReportResult => {
    const query = useClientController_RangeLiceReports(clientId, { from, to }, options);

    const rangeReport = useMemo(() => {
        if (!query.data?.data) return null;
        return mapRangeClientReportResultToDomain(query.data.data);
    }, [query.data?.data]);

    return {
        data: rangeReport,
        isLoading: query.isPending,
        isFetching: query.isFetching,
        isFetched: query.isFetched,
        error: query.error,
        refetch: query.refetch,
    };
};
